export default __webpack_public_path__ + "static/media/study.8822aaa3.png";